export enum AcaoTipoHistorico {
  CRIACAO = 0,
  APROVACAO = 1,
  FECHAMENTO = 2,
  EXCLUSAO = 3,
  REABERTURA = 4,
  EXECUCAO = 5,
  ALTERACAO = 6
}
